import React, { useState, useEffect } from "react";
import createNetworkingClient from "../../utils/networking-client";
import { logError } from '../../utils/sentry';
import ActivityDetailsMap from "./ActivityDetailsMap";

import type { BaseActivityDetailsMapProps, StreamsData } from "./types";

const ActivityDetailsMapWrapper = (props: BaseActivityDetailsMapProps) => {
  const [streamData, setStreamData] = useState<StreamsData>(null);
  
  const { activityId } = props;

  useEffect(() => {
    const fetchStreams = async () => {
      try {
        const response = await createNetworkingClient().get(`/activities/${activityId}/streams`, {
          params: {
            stream_types: ["latlng", "privacy", "distance", "altitude"]
          }
        });

        if (!response || response.status !== 200) {
          logError("ActivityDetailsMapWrapper: Request failed");
        }

        setStreamData(response.data);
      } catch (error) {
        logError("ActivityDetailsMapWrapper: Error fetching streams:", error);
      }
    };

    if (!streamData) {
      fetchStreams();
    }
  }, [activityId, streamData]);

  // If essential stream data is missing, do not attempt to render the map
  if (!streamData || !streamData.latlng || !streamData.distance) {
    return null;
  }

  return <ActivityDetailsMap {...props} streamData={streamData} />;
};

export default ActivityDetailsMapWrapper;